<template>
  <div class="emails-wrapper">
    <div class="top">
      <div class="title">
        {{ label }} <span v-if="required" class="required">(Required)</span>
      </div>
      <div v-if="withAddBtn" class="openModal" @click="isModalOpen = true">
        Add
      </div>
    </div>
    <div
      class="emails"
      :class="{ ['clickable']: !withAddBtn }"
      @click="!withAddBtn ? (isModalOpen = true) : null"
    >
      {{ emailsArrToString }}
    </div>
    <VElementsAddingModal
      v-bind="_innerChildProps"
      :isOpen="isModalOpen"
      :elements="elements"
      @save="value => _updateValue(value)"
      @close="isModalOpen = false"
    ></VElementsAddingModal></div
></template>

<script>
import Vue from "vue";
import VueTypes from "vue-types";
import { mapActions } from "vuex";

import VElementsAddingModal from "@/components/VElementsAddingModal";

export default Vue.component("VMultipleElementsCreator", {
  props: {
    formName: VueTypes.string,
    //fieldName
    name: VueTypes.string,
    label: VueTypes.string,
    value: VueTypes.string.def(""),
    innerChildProps: VueTypes.object,
    withAddBtn: VueTypes.bool.def(true),
    required: VueTypes.bool
  },

  data() {
    return {
      fieldName: this.name,
      isModalOpen: false,
      elements: [this.value]
    };
  },

  component: { VElementsAddingModal },

  computed: {
    _innerChildProps() {
      return this.innerChildProps["modal"];
    },

    emailsArrToString() {
      return this.elements.length > 0 ? this.elements.join(",") : "";
    }
  },

  methods: {
    _updateValue(value) {
      this.elements = value;
      this.updateValue({
        formName: this.formName,
        fieldName: this.fieldName,
        value: value
      });
    },

    ...mapActions("forms", ["updateValue"])
  }
});
</script>

<style lang="scss" scoped>
.emails-wrapper {
  color: $primary-text-color;

  .top {
    display: flex;
    justify-content: space-between;
    padding: 0 0 14px 8px;
  }

  .title {
    font-family: "Lato-Bold", Arial, sans-serif;
    font-size: 15px;

    .required {
      font-family: Lato-Light, Arial, Helvetica Neue, Helvetica, sans-serif;
    }
  }

  .openModal {
    color: $primary-color;
    cursor: pointer;
  }

  .emails {
    width: 100%;
    padding: 10px;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
  }
}
</style>
